<h3 style="text-align: center;">Basel Country Index</h3>

        <div class="col-12" style="width: 2000px;height:700px;">
            <pdf-viewer 
                src="/assets/pdf/compliance/baselCountryRule.pdf"
                [rotation]="0"
                [original-size]="true"
                [show-all]="true"
                [fit-to-page]="true"
                [zoom]="1.2"
                [zoom-scale]="'page-width'"
                [stick-to-page]="true"
                [render-text]="true"
                [external-link-target]="'blank'"
                [autoresize]="true"
                [show-borders]="false"
         
                class="viewer" >
            </pdf-viewer>
         </div>
    